import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { Router } from '@angular/router';

@Component({
  selector: 'app-redirect-dialog',
  templateUrl: './redirect-dialog.component.html',
  styleUrls: ['./redirect-dialog.component.scss']
})
export class RedirectDialogComponent {

  message = "";
  redirect = "";

  constructor(public dialogRef: MatDialogRef<RedirectDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: any, private router: Router) {}

  ngOnInit() {  
    this.dialogRef.backdropClick().subscribe( x => {
      this.dialogRef.close();
    });
    this.dialogRef.keydownEvents().subscribe(event => {
      if (event.key === "Escape") {
        this.dialogRef.close();
      }
    });
    this.message = this.data.message;
    this.redirect = this.data.redirect;
  }

  ok() {
    this.dialogRef.close();
  }

  okRedirect() {
    this.router.navigateByUrl(this.redirect);
    this.dialogRef.close();
  }
}
